<p>stock-actual-qty works!</p>
